import { OfferStatusInfo } from "../../../../widgets/OfferStatusInfo";
import Wait from "../../../../shared/assets/icons/waiting.svg";
import { useAppSelector } from "../../../../shared/store";
import { fetchFinger } from "../../../../shared/store/payment/actions";
import { useAppDispatch } from "../../../../shared/store";
import { useEffect } from "react";

export const Waiting = () => {
  const offerData = useAppSelector((state) => state.payment.offer);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchFinger());
  }, []);

  return (
    <OfferStatusInfo
      iconSrc={Wait}
      isRotate={true}
      title="Ваш счет формируется"
      description="Ожидайте, ваш счет формируется. В скором времени вы увидите нужную информацию"
      buttonVariant="primary"
      link={offerData?.goodLink}
      isBtnVisible={!!offerData?.goodLink}
    />
  );
};
